import React from 'react';
import {
  injectStripe,
  PaymentRequestButtonElement,
} from 'react-stripe-elements';
import { toast } from 'react-toastify';
import Preloader from '../../../components/Preloader/Preloader';
import styles from './PaymentRequestForm.mod.css';
import { toastResponseErrors } from '../../../utils/response';

class PaymentRequestForm extends React.Component {
  constructor(props) {
    super(props);

    // For full documentation of the available paymentRequest options, see:
    // https://stripe.com/docs/stripe.js#the-payment-request-object
    const paymentRequest = props.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Monthly',
        amount: 300,
      },
    });

    paymentRequest.on('token', ({ complete, token, ...data }) => {
      const { subscriptionPlan, getSubscription } = props;
      const { id } = subscriptionPlan;
      const card = token.card.last4;
      getSubscription({ stripe_token: token.id, plan_id: id })
        .then(() => {
          toast.success(`The card **** **** **** ${card} successfully added!`);
        })
        .catch(toastResponseErrors);
      console.log('Received customer information: ', data);
      complete('success');
    });

    paymentRequest.canMakePayment().then(result => {
      this.setState({ canMakePayment: !!result, loading: false });
    });

    this.state = {
      canMakePayment: false,
      loading: true,
      paymentRequest,
    };
  }

  render() {
    return (
      <div className={styles.paymentRequest}>
        <Preloader isActive={this.state.loading} />
        {this.state.canMakePayment && !this.props.isSubscribed ? (
          <PaymentRequestButtonElement
            paymentRequest={this.state.paymentRequest}
            className="PaymentRequestButton"
            style={{
              // For more details on how to style the Payment Request Button, see:
              // https://stripe.com/docs/elements/payment-request-button#styling-the-element
              paymentRequestButton: {
                theme: 'light',
                height: '64px',
              },
            }}
          />
        ) : (
          <div className={styles.info}>
            {this.props.isSubscribed
              ? 'You already have subscribed'
              : 'Save a card in Chrome, add a card to your Google Pay account or add a card to your Wallet for Safari.'}
          </div>
        )}
      </div>
    );
  }
}

export default injectStripe(PaymentRequestForm);



// WEBPACK FOOTER //
// ./src/containers/Billing/components/PaymentRequestForm.jsx